module.exports = __webpack_public_path__ + "media/images/emblems/Saint-Livres-coat_of_arms-0819a4d9870320ea3c76d20dc9e0135f.svg";